import { h, Component } from 'preact';
import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { actionHandler } from '../../../utilities/form/formUtils';
import { translateName } from '../../../utilities/common';
import Icon from '../../Global/Icon';
import Text from '../../Global/Text';
import Trans from '../../Global/Translation';

class ProductsOverview extends Component {
  constructor(props) {
    super(props);
    this.fullPageHook = this.fullPageHook.bind(this);
  }

  componentDidMount() {
    document.body.classList.add('footer-control-open', 'header-open');
    document.body.classList.remove('footer-control-normal', 'footer-control-close', 'header-close');
  }

  fullPageHook(hook) {
    this.state.hook = hook;
  }

  render() {
    const {
      userData,
      coverageInfo,
      header,
      headerFamilyText,
      headerCityText,
      dispatch,
      values,
      setValues,
    } = this.props;

    const { recommendation, questionaries } = userData;
    const productCount = Object.keys(recommendation).length;
    const recommendedOuterClassName = `products-overview-content--inner products-overview-product--count-${productCount}`;
    const recommendationDetails = (productName, index, isMobile) => {
      const recommendationDetail = recommendation[productName];
      const percentage = recommendationDetail.prevalence;
      const percentageVal = percentage.toString();
      let dynamicHeightStyle;
      let prodName;
      const iconName = coverageInfo[productName].icon;
      const fromIcon = coverageInfo[productName].iconFrom;
      if (isMobile) {
        dynamicHeightStyle = {
          paddingTop: `${percentage / 2}%`,
        };
        prodName = `${productName}-product-name-mobile`;
      } else {
        dynamicHeightStyle = {
          paddingTop: `${percentage / 4}%`,
          width: `${100 / productCount}%`,
        };
        prodName = `${productName}-product-name`;
      }
      let iconNameDisplay;
      switch (fromIcon) {
        case 'questionaries': {
          const iconDisplay = questionaries && questionaries.filter(item => {
            return item.id === iconName;
          });
          iconNameDisplay = iconDisplay && iconDisplay[0].value;
          break;
        }

        case 'propertyTypeHousehold': {
          iconNameDisplay = `${userData[iconName]}Household`;
          break;
        }

        default:
          iconNameDisplay = userData[iconName];
      }
      const iconNameTranslate = translateName(iconNameDisplay);
      const pdtClass = `products-overview-products products-overview-products--${index}`;
      return (
        <div
          className={pdtClass}
          style={dynamicHeightStyle}
          aria-hidden="true"
          onClick={e => actionHandler(coverageInfo[productName].actions, null, e, dispatch,
               values, setValues)}
        >
          <div className="products-overview-products--content">
            <div>
              <Text value={percentageVal} component="span" />
              <Text value='%' component="span" />
            </div>
          </div>
          <div className="products-overview-coverage--icon">
            {iconNameDisplay &&
              <Icon className={iconNameTranslate} icon={iconNameDisplay.replace(/[ ,]/g, '')} fill="black" businessUnitName={userData.businessUnitName}/>
            }
          </div>
          <div className='product-button-wrapper'>
            <button
              type='button'
              className='button button--secondary'
              onClick={e => actionHandler(coverageInfo[productName].actions, null, e, dispatch,
                 values, setValues)}
            >
              <Trans value={prodName} />
              <Icon icon="chevronLeft" fill="white"/>
            </button>
          </div>
          <br/>
          <br/>
        </div>
      );
    };

    return (
      <div className="section--container">
        <article className="products-overview-outer">
          <div className="products-overview-content products-overview-content--product" id="products-overview-product">
            <h2 className="products-overview-header">
              <Text value={header} component="span" className="products-overview-header--transform" />
              <Trans value={userData[headerFamilyText]} component="strong" />
              <Text value={headerCityText} component="span" />
            </h2>
            <div className={recommendedOuterClassName}>
              {recommendation &&
                <div>
                  <MediaQuery minWidth={768}>
                    <div className="products-overview-content--product-inner">
                      {Object.keys(recommendation).map((recommendationDetail, index) => {
                        return recommendationDetails(recommendationDetail, index, false);
                      })}
                    </div>
                  </MediaQuery>
                  <MediaQuery maxWidth={767}>
                    <div className="products-overview-content--product-inner">
                      {Object.keys(recommendation).map((recommendationDetail, index) => {
                        return recommendationDetails(recommendationDetail, index, true);
                      })}
                    </div>
                  </MediaQuery>
                </div>
              }
            </div>
          </div>
        </article>
      </div>
    );
  }
}

export default ProductsOverview;

ProductsOverview.defaultProps = {
  coverageInfo: null,
  header: '',
  headerFamilyText: '',
  headerCityText: '',
  values: null,
};

ProductsOverview.propTypes = {
  userData: PropTypes.object.isRequired,
  coverageInfo: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  header: PropTypes.string,
  headerFamilyText: PropTypes.string,
  headerCityText: PropTypes.string,
  values: PropTypes.object,
  setValues: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Steps/General/ProductsOverview.jsx